import { useState, useMemo } from 'react';
import cat from 'assets/cat.jpeg';
import { Tabs, Tab, withStyles } from '@material-ui/core';
import classes from './ReviewQualifiedRealPlay.module.scss';
import User from 'infrastructure/User';
import { Avatar } from '@material-ui/core';
import CopyComponent from '../Common/CopyComponent';
import CopyTranscription from '../Common/CopyTranscription';
import DownloadComponent from '../Common/DownloadComponent';
import InputComponent from '../Common/InputComponente';
import useGetAssignmentTranscriptionQuery from 'features/realplays/services/queries/useGetAssignmentTranscription';
import { CircularProgress } from '@material-ui/core';
import { SentimentDissatisfied } from '@material-ui/icons';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';
import RealPlayQualifiedDataHelper from 'features/realplays/RealPlayQualifiedData.helper';
import LoadingTranscription from '../ReportResult/LoadingTranscription';

const AntTabs = withStyles({
  root: {
    minHeight: '1rem',
  },
  indicator: {
    backgroundColor: '#0494FD',
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    minHeight: '2rem',
    fontWeight: 600,
    marginRight: '1rem',
    padding: '0px  10px',
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$selected': {
      color: '#193448',
      fontWeight: 600,
    },
    '&:focus': {
      color: '#40a9ff',
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

const RealPlayRightSection = ({ isLoading, loadingScenarioResponseInfo }) => {
  const [value, setValue] = useState(0);
  const [search, setSearch] = useState('');

  const { assignment_uuid, assigned_by_user, client, customer_context, selectedScenario } =
    RealPlayRecordDataHelper();

  const { transcription, summary, status_ai } = RealPlayQualifiedDataHelper();

  const userName = useMemo(
    () =>
      assigned_by_user ? `${assigned_by_user?.first_name} ${assigned_by_user?.last_name}` : 'User',
    [assigned_by_user]
  );
  const clientName = useMemo(() => (client ? client?.name : 'Customer'), [client]);

  const { isLoading: isLoadingTranscription } = useGetAssignmentTranscriptionQuery({
    assignment_uuid,
    scenario_uuid: selectedScenario?.uuid,
    response_uuid: selectedScenario?.response?.uuid,
    enabled:
      !!assignment_uuid &&
      !!selectedScenario?.uuid &&
      !!selectedScenario?.response?.uuid &&
      value === 1,
    clientName,
    userName,
  });

  const filteredTranscript = useMemo(() => {
    if (!transcription || transcription?.length === 0) return [];
    if (search === '') return transcription;
    return transcription?.filter(
      (item) =>
        item.content.toLowerCase().includes(search.toLowerCase()) ||
        item.role.toLowerCase().includes(search.toLowerCase()) ||
        item.name.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, transcription]);

  const handleChange = (event, newValue) => setValue(newValue);
  const handleInputChange = (e) => setSearch(e.target.value);

  return (
    <div>
      <div>
        <AntTabs value={value} onChange={handleChange} aria-label="ant example">
          <AntTab label="Coaching" />
          <AntTab label="Transcription" />
        </AntTabs>
      </div>
      <TabPanel value={value} index={0}>
        {isLoading || loadingScenarioResponseInfo ? (
          <CircularProgress size={18} color="inherit" />
        ) : (
          <div className={classes.coachingContainer}>
            {status_ai === 'UNRATED' || status_ai === 'FAILED' || status_ai === 'QUEUED' ? (
              <div className={classes.errorContainer}>
                <div>
                  <SentimentDissatisfied fontSize="small" />
                  <p style={{ fontSize: '12px' }}>
                    We’re {status_ai === 'QUEUED' ? '' : 'unable to'} generate a summary right now.
                    Refresh or try again later.
                  </p>
                  {status_ai !== 'QUEUED' && <p>ERROR CODE 000-000</p>}
                </div>
              </div>
            ) : (
              <>
                <div className={classes.title}>Summary</div>
                {summary && summary?.strengths?.length > 0 && (
                  <div className={classes.subTitle}>💪 Strengths</div>
                )}
                <div className={classes.list}>
                  <ul>
                    {summary?.strengths?.map((item, index) => {
                      return (
                        <li key={`Strengths-${index}`}>
                          {typeof item === 'string' ? item : item?.strength}
                        </li>
                      );
                    })}
                  </ul>
                </div>

                {summary && summary?.areas_of_improvement?.length > 0 && (
                  <div className={classes.subTitle}>📌 Areas of improvement</div>
                )}
                <div className={classes.list}>
                  <ul>
                    {summary?.areas_of_improvement?.map((item, index) => (
                      <li key={`AreasOI-${index}`}>
                        {typeof item === 'string' ? item : item?.improve}
                      </li>
                    ))}
                  </ul>
                </div>
              </>
            )}
            <div className={classes.title} style={{ marginTop: '0.5rem' }}>
              Prospect context
            </div>
            <div className={classes.customerContainer}>
              <div>
                <p className={classes.deadlineTitle}>Role:</p>
                <span>{customer_context?.role}</span>
              </div>
              <div>
                <p className={classes.deadlineTitle}>Industry:</p>
                <span>{customer_context?.industry}</span>
              </div>
              <div>
                <p className={classes.deadlineTitle}>Situation: </p>
                <span>{customer_context?.situation}</span>
              </div>
            </div>
          </div>
        )}
      </TabPanel>
      <TabPanel value={value} index={1}>
        {isLoading || isLoadingTranscription ? (
          <LoadingTranscription />
        ) : !transcription || transcription?.length === 0 ? (
          <div className={classes.errorContainer}>
            <div>
              <SentimentDissatisfied fontSize="small" />
              <p style={{ fontSize: '12px' }}>
                We’re unable to get the transcription right. Refresh or try again later.
              </p>
              <p>ERROR CODE 000-000</p>
            </div>
          </div>
        ) : (
          <div className={classes.transcriptionContainer}>
            <div className={classes.buttonsContainer}>
              <InputComponent value={search} handleChange={handleInputChange} />
              <div className={classes.actions}>
                <CopyTranscription transcription={transcription} />
                <DownloadComponent transcription={transcription} />
              </div>
            </div>
            <div className={classes.columnContainer}>
              {filteredTranscript?.length > 0 ? (
                filteredTranscript?.map((item, index) => (
                  <div
                    className={classes.columnContainer}
                    key={`T-${index}`}
                    style={{ marginBottom: '1.1rem', gap: '0.2rem' }}
                  >
                    <div className={classes.imageContainer}>
                      {item?.role === 'user' ? (
                        <>
                          <Avatar
                            className={classes.avatar}
                            alt=""
                            src={assigned_by_user?.profile_pic}
                          >
                            {User.getInitial(assigned_by_user) || 'U'}
                          </Avatar>
                          <p>{userName}</p>
                        </>
                      ) : (
                        <>
                          <Avatar
                            className={classes.avatar}
                            alt=""
                            src={client?.profile_pic ? client?.profile_pic : cat}
                          />
                          <p>{clientName}</p>
                        </>
                      )}
                      <div className={classes.time}>
                        {item?.timestamp.toString().replace('.', ':')}{' '}
                      </div>
                    </div>
                    <div className={classes.rowContainer}>
                      <CopyComponent text={item?.content} />
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ color: '#78909c' }}>No matching results were found.</p>
              )}
            </div>
          </div>
        )}
      </TabPanel>
    </div>
  );
};

export default RealPlayRightSection;
